import {
  setGalleryButtonsEventsXml,
  setGalleryButtonsImgXml,
  setGalleryScaleXml,
  setGalleryPositionXml,
  setCurrentGalleryVariableXml
} from './action-gallery'

export const actionTagXml = () => {
  const setScaleAndHtmlXml = `
    <action name="set_webXR_marker_tag_scale_html" scope="local" args="title, price, description">
      ${setGalleryScaleXml}
      set_marker_scale_html('markerInfoBg', 1, null);
      set_marker_scale_html('markerCloseButton', 1, null);
      set_marker_scale_html('markerFavoriteButton', 1, null);
      set_marker_scale_html('markerInfoTitle', 1, get(title));
      if (get(price) !== "",
        set_marker_scale_html('markerInfoPrice', 1, get(price));
      );
      set_marker_scale_html('markerInfoDescription', 1, get(description));
    </action>
  `
  const setPositionXml = `
    <action name="set_webXR_marker_tag_position" scope="local" args="ath, atv">
      ${setGalleryPositionXml}
      set_marker_position('markerInfoBg', get(ath), get(atv));
      set_marker_position('markerCloseButton', get(ath), get(atv));
      set_marker_position('markerFavoriteButton', get(ath), get(atv));
      set_marker_position('markerInfoTitle', get(ath), get(atv));
      if (get(price) !== "",
        set_marker_position('markerInfoPrice' ,get(ath), get(atv));
      );
      set_marker_position('markerInfoDescription' ,get(ath), get(atv));
    </action>
    `
  const setSizeXml = `
    <action name="set_webXR_marker_tag_size"  scope="local">
      <!-- bg -->
      set(bg_width, calc(haveGallery ? 1280 : 800));
      set(bg_height, calc(haveGallery ? 720 : 600));
      <!-- photo -->
      txtadd(markerPhoto, 'markerInfoImage_0_', get(currentObjectId));
      set(photo_width, get(hotspot[%markerPhoto].width));
      set(photo_height, get(hotspot[%markerPhoto].height));
      <!-- title / price / description -->
      set(content_width, calc(haveGallery ? 628 : 650));
      set(title_width, get(content_width));
      def(title_height, number, 76);
      set(price_width, get(content_width));
      def(price_height, number, 36);
      set(description_width, get(content_width));
      set(description_height, calc(haveGallery ? 288 : 120));

      set_marker_size(get(markerPhoto), get(photo_width), get(photo_height));
      set_marker_size('markerInfoBg', get(bg_width), get(bg_height));
      set_marker_size('markerInfoTitle', get(title_width), get(title_height));
      set_marker_size('markerInfoPrice', get(price_width), get(price_height));
      set_marker_size('markerInfoDescription', get(description_width), get(description_height));
    </action>
    `
  const defineOffsetXml = `
    def(gap, number, 20);
    <!-- background -->
    set(bg_px, calc(haveGallery ? 50 : 75));
    set(bg_pt, calc(haveGallery ? 112 : 125));
    set(bg_width, get(hotspot[markerInfoBg].width));
    set(bg_height, get(hotspot[markerInfoBg].height));
    <!-- start position -->
    set(start_ox, calc(0 - (bg_width / 2) + bg_px));
    set(start_oy, calc(0 - (bg_height / 2) + bg_pt));

    <!-- Gallery -->
    if (haveGallery,
      txtadd(markerPhoto, 'markerInfoImage_0_', get(currentObjectId));
      set(photo_width, get(hotspot[%markerPhoto].width));
      set(photo_height, get(hotspot[%markerPhoto].height));
      set(photo_ox, calc(start_ox + photo_width / 2));
      set(photo_oy, calc(start_oy + photo_height / 2));
      <!-- Button -->
      set(prev_ox, calc(start_ox));
      set(prev_oy, calc(start_oy + photo_height / 2));
      txtadd(markerName, 'markerPrev_', get(currentObjectId));
      set(next_ox, calc(start_ox + 422));
      set(next_oy, calc(start_oy + photo_height / 2));
      txtadd(markerName, 'markerScaleUp_', get(currentObjectId));
      set(scaleUp_ox, calc(start_ox + 354));
      set(scaleUp_oy, calc(start_oy + 422));
      set(scaleDown_ox, calc(start_ox + 422));
      set(scaleDown_oy, calc(start_oy + 422));
    );
    <!-- close & favorite button -->
    def(btn_mt, number, 35);
    set(close_ox, calc(haveGallery ? calc(0 - (bg_width / 2) + 1180) : calc(0 - (bg_width / 2) + 700)));
    set(close_oy, calc(0 - (bg_height / 2) + btn_mt));
    set(favorite_ox, calc(haveGallery ? calc(0 - (bg_width / 2) + 1097) : calc(0 - (bg_width / 2) + 617)));
    set(favorite_oy, get(close_oy));
    <!-- title -->
    set(title_height, get(hotspot[markerInfoTitle].height));
    set(price_height, get(hotspot[markerInfoPrice].height));
    set(title_ox, get(start_ox));
    set(title_oy, get(start_oy));
    <!-- price -->
    set(price_ox, get(start_ox));
    set(price_oy, calc(title_oy + title_height + gap));
    <!-- description -->
    set(description_ox, get(start_ox));
    set(description_oy, calc(title_oy + title_height + gap));
  `
  const calcOffsetXml = `
    <!-- with price -->
    if (Boolean(get(hasPrice)) == true,
      set(description_oy, calc(price_oy + price_height + gap));
    );
    <!-- with Gallery -->
    if (haveGallery,
      <!-- isRtl -->
      set(with_photo_ox, calc(photo_width + bg_px)); <!-- 加上相片後，文字往右移 -->
      if (Boolean(get(isRtl)) == true,
        set(title_ox, calc(0 - title_ox - with_photo_ox));
        set(price_ox, calc(0 - title_ox - with_photo_ox));
        set(description_ox, calc(0 - title_ox - with_photo_ox));
      ,
        set(title_ox, calc(title_ox + with_photo_ox));
        set(price_ox, calc(price_ox + with_photo_ox));
        set(description_ox, calc(description_ox + with_photo_ox));
      );
    );
    <!-- without photo and is Rtl -->
    if (get(haveGallery) AND Boolean(get(isRtl)) == true,
      set(bg_ox, -10);
      set(title_ox, -10);
      set(price_ox, -10);
      set(description_ox, -10);
    );
  `
  const setOffsetResultXml = `
    <!-- close button -->
    set_marker_offset('markerCloseButton', get(close_ox), get(close_oy));
    set_marker_offset('markerFavoriteButton', get(favorite_ox), get(favorite_oy));
    <!-- title -->
    set_marker_offset('markerInfoTitle', get(title_ox), get(title_oy));
    <!-- price -->
    set_marker_offset('markerInfoPrice', get(price_ox), get(price_oy));
    <!-- Description -->
    set_marker_offset('markerInfoDescription', get(description_ox), get(description_oy));
    <!-- Gallery -->
    if (haveGallery ,
      txtadd(markerName, 'markerInfoImage_0_', get(currentObjectId));
      set_marker_offset(get(markerName), get(photo_ox), get(photo_oy));
    );
    if (imagesLength GE 2 ,
      set(photo_ox, calc(photo_ox + photo_width));
      for (set(i, 1), i LT imagesLength, inc(i),
        txtadd(markerName, 'markerInfoImage_', get(i), '_', get(currentObjectId));
        set_marker_offset(get(markerName), get(photo_ox), get(photo_oy));
      );
    );

    <!-- Button -->
    txtadd(markerName, 'markerPrev_', get(currentObjectId));
    set_marker_offset(get(markerName), get(prev_ox), get(prev_oy));
    txtadd(markerName, 'markerNext_', get(currentObjectId));
    set_marker_offset(get(markerName), get(next_ox), get(next_oy));
    txtadd(markerName, 'markerScaleUp_', get(currentObjectId));
    set_marker_offset(get(markerName), get(scaleUp_ox), get(scaleUp_oy));
    txtadd(markerName, 'markerScaleDown_', get(currentObjectId));
    set_marker_offset(get(markerName), get(scaleDown_ox), get(scaleDown_oy));`
  const setOffsetXml = `
    <action name="set_webXR_marker_tag_offset" scope="local" args="isRtl, hasPrice">
      ${defineOffsetXml}
      ${calcOffsetXml}
      ${setOffsetResultXml}
    </action>
    `
  return `
    ${setCurrentGalleryVariableXml}
    ${setGalleryButtonsImgXml}
    ${setGalleryButtonsEventsXml}
    ${setScaleAndHtmlXml}
    ${setPositionXml}
    ${setSizeXml}
    ${setOffsetXml}
    `
}
